<template>
  <div class="comments-grid">
    <div class="comments-card">
      <div class="section-title negative">Detractores</div>
        <ul class="comments-list comment-list">
          <li v-for="(item, index) in comments.detractors" :key="`d-${index}`">
            <div class="comment-text">{{ item.text }}</div>
            <div class="comment-meta">{{ item.date }}<span v-if="item.device"> | {{ item.device }}</span><span v-if="item.device_group"> | {{ item.device_group }}</span></div>
          </li>
          <li v-if="!comments.detractors.length" class="empty-item">Sin comentarios</li>
        </ul>
    </div>
    <div class="comments-card">
      <div class="section-title neutral">Neutros</div>
        <ul class="comments-list comment-list">
          <li v-for="(item, index) in comments.neutrals" :key="`n-${index}`">
            <div class="comment-text">{{ item.text }}</div>
            <div class="comment-meta">{{ item.date }}<span v-if="item.device"> | {{ item.device }}</span><span v-if="item.device_group"> | {{ item.device_group }}</span></div>
          </li>
          <li v-if="!comments.neutrals.length" class="empty-item">Sin comentarios</li>
        </ul>
    </div>
    <div class="comments-card">
      <div class="section-title positive">Promotores</div>
        <ul class="comments-list comment-list">
          <li v-for="(item, index) in comments.promoters" :key="`p-${index}`">
            <div class="comment-text">{{ item.text }}</div>
            <div class="comment-meta">{{ item.date }}<span v-if="item.device"> | {{ item.device }}</span><span v-if="item.device_group"> | {{ item.device_group }}</span></div>
          </li>
          <li v-if="!comments.promoters.length" class="empty-item">Sin comentarios</li>
        </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NpsReplicaCommentsSection',
  props: {
    comments: {
      type: Object,
      default: function () {
        return {
          promoters: [],
          neutrals: [],
          detractors: []
        };
      }
    }
  }
};
</script>

<style scoped>
.comments-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(3, 1fr);
}

.comments-card {
  background: var(--bg-card, #FFFFFF);
  border-radius: 12px;
  box-shadow: var(--card-shadow, 0 2px 12px rgba(26,26,46,0.08));
  min-height: 360px;
  padding: 20px 22px;
}

.section-title {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 16px;
}

.positive {
  color: #28A745;
}

.neutral {
  color: #FFC107;
}

.negative {
  color: #DC3545;
}

.comments-list {
  list-style: none;
  margin: 0;
  max-height: 280px;
  overflow-y: auto;
  padding: 0;
}

.comments-list li {
  background: #F8FAFF;
  border-left: 3px solid transparent;
  border-radius: 4px;
  margin-bottom: 4px;
  padding: 7px 10px;
}

.comment-text {
  color: #374151;
  font-size: 12px;
  line-height: 1.4;
  margin-bottom: 6px;
}

.comment-meta,
.empty-item {
  color: rgba(0, 0, 0, .54);
  font-size: 11px;
}

.comments-card:first-child .comments-list li {
  border-left-color: #DC3545;
}

.comments-card:nth-child(2) .comments-list li {
  border-left-color: #FFC107;
}

.comments-card:nth-child(3) .comments-list li {
  border-left-color: #28A745;
}

@media (max-width: 900px) {
  .comments-grid {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/rounds/nps-dashboard/components/CommentsSection.vue